import { useMemo } from 'react'
import { OrderFormData, OrderFields } from 'types/order'
import { FileForDocumentsForm, FileProps, FileType } from 'types/file'
import { getHiddenRecognizedFileUuids } from 'utils/file'

export const useDocumentPreviews = (form: OrderFormData): { [key in FileType]: FileForDocumentsForm[] } =>
  useMemo(() => {
    const files = form[OrderFields.FILES]
    const hiddenUuids = getHiddenRecognizedFileUuids(files as FileProps[])

    return files.length // @ts-ignore TODO remove
      ? files.reduce((list: { [key in FileType]: FileForDocumentsForm[] }, item: FileProps | number) => {
          if (typeof item === 'number' || item.data?.isDeleted || hiddenUuids.has(item.uuid) || (!item.data?.recognitionType && !item.data?.type))
            return list

          const type = (item.data?.type || item.data?.recognitionType) as FileType

          const result = {
            ...list,
          }
          result[type] = [
            ...(result[type] || []),
            {
              name: item.name,
              href_file: item.uuid,
              data: item.data,
            },
          ]

          return result
        }, {})
      : {}
  }, [form])
